module.exports = __webpack_public_path__ + "img/rekkaparkki_white.58ecacb1.png";